<script lang="ts">
    import { Button } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/ComponentData/BonusUi/BonusUi.json"
    import { DisableButtonMessage, Disabled,DisableButton } from "../../../utils/Constant/Constant";
</script>
<Card headerTitle={DisableButton} cardHeaderprops="pb-0" cardBodyprops="btn-showcase">
    <div slot="customheader">
        <span>{@html DisableButtonMessage}</span>
    </div>
    <div slot="contentbody">
        <Button disabled class="btn-pill btn-air-primary" color="primary">{Disabled}</Button>
        {#each data.buttoncolordata as buttonItem}
            <Button active class="btn-pill btn-air-{buttonItem.color}" color={buttonItem.color}>{Disabled}</Button>
        {/each}
    </div>
</Card>
